import HistoryDetails from '../../../../patient/details/history/HistoryDetails'

export default function HistoryDrawerTab({ classes, column = 5 }) {
    return (
        <div className={`${classes.block} ${classes[`block_${column}`]}`}>
            <HistoryDetails />
        </div>
    )
}
